//AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - Start
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { BzCard, BzChip, BzScrollContainer } from '../../components';
import { Container, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { handleModal, handleModalData } from '../../redux/actions/modals';
import { convertAlertToWatchlistGrid, getApiExchangeNameFromMktSegId, getDynamicParamsForToFixed, getScripDisplayDescription, handleScripUnsubScriptionOnUnMount, scrollContainerObserver } from '../../utils/global_functions';
import AlertNameDetails from './AlertNameDetails';
import ZeroStates from '../ZeroStates';//ManasaB : 11/12/2023 : BT-123413 : ALerts Bug Fixing - 3 
import { sendTouchlineRequest } from '../../apis/web_socket';
import { TL_INDEX, WATCHLIST_GRID_INDEX } from '../../utils/global_variables';
import { useUnload, useWFHMessages } from '../../hooks';
import { getWfhTouchlineLastTick } from '../../redux/actions/wfh';

const Alert = ({ isVertical, selectAllCheckbox = false, AlertPortfolio, arrAlertAttributes, bShowDeleteCheckbox, handleSelectAlertForDelete, arrSelectedDeleteAlert, handleDeleteSingleAlert }) => {
    const dispatch = useDispatch();
    let containerRef = useRef(null);
    const arrAlerts = useSelector(state => state?.alerts?.arrAlerts);
    const scripOverviewData = useSelector(state => state?.marketOverview?.scripOverviewData);
    // Azeem K - 23-05-2024 BT-107432 Breeze - Alerts: Added Livefeed data -- Start 
    const [arrActiveAlert, setArrActiveAlerts] = useState([]);
    const updateAlertWithTouchlineData = (arrTouchLineData) => {
        setArrActiveAlerts(arrAlerts => {
            if (arrAlerts?.length > 0) {
                let arrFilt = arrAlerts?.filter((alert) => alert?.mktIdToken === arrTouchLineData[TL_INDEX.SEGMENT_ID]?.toString() + '_' + arrTouchLineData[TL_INDEX.TOKEN]?.toString());
                for (let i = 0; i < arrFilt?.length; i++) {
                    const nIndex = arrAlerts?.findIndex(item => item?.serverAlertId === arrFilt[i]?.serverAlertId);
                    arrFilt[i].ltp = arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE];
                    arrFilt[i].changeInPrice = arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE];
                    arrFilt[i].changeInPercent = arrTouchLineData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE];
                    arrAlerts[nIndex] = arrFilt[i];
                }
            } else { }
            return [...arrAlerts];
        });
    };

    useWFHMessages('touchline', (e) => {
        updateAlertWithTouchlineData([...e.detail]);
    });


    // Azeem K - 23-05-2024 BT-107432 Breeze - Alerts: Added Livefeed data -- End 
    const handleEditAlert = (data) => {
        dispatch(handleModalData({
            AlertData: {
                symbol: data?.symbol,
                exchange: data?.exchange,
                series: data?.series,
                description: getScripDisplayDescription(convertAlertToWatchlistGrid(data)),
                token: data?.nToken,
                mktId: data?.segmentId,
                decimalLocator: data?.decimalLocator,
                decimalLocator_length: getDynamicParamsForToFixed(data?.exchange),
                exchange_segement: getApiExchangeNameFromMktSegId(data?.segmentId)


            }, modifyData: data, isEditable: true
        }));
        dispatch(handleModal([{ "SET_ALERT_MODAL": true }]));
    };

    // Vinit R - 24-04-2024 BT-107432 Breeze - Alerts -- Start
    const filterAlerts = (arr, objefilter) => {
        // Deepti B. 107432 Breez Alerts: category and alert filter fixes -- start
        return arr.filter(item => {
            const categoryMatch = objefilter?.selectedCategory ? item.category === objefilter?.selectedCategory : true;
            const alertMatch = objefilter?.selectedAlerts ? item.factor1 === objefilter?.selectedAlerts : true;
            return categoryMatch && alertMatch;
        });
        // Deepti B. 107432 Breez Alerts: category and alert filter fixes -- end
    };

    const strSearchAlertBySymbol = useSelector(state => state?.alerts?.strSearchAlertBySymbol);
    const objFilterAlertFromModal = useSelector(state => state?.alerts?.objFilterAlertFromModal);

    let arrAlrtScripData = useMemo(() => {
        let temp = arrActiveAlert;
        if (Object.keys(objFilterAlertFromModal)?.length && (objFilterAlertFromModal?.selectedCategory || objFilterAlertFromModal?.selectedAlerts)) {
            temp = filterAlerts(temp, objFilterAlertFromModal);
        }
        temp = strSearchAlertBySymbol ?
            temp?.filter((scrip) => scrip?.symbol?.toUpperCase()?.includes(strSearchAlertBySymbol?.toUpperCase()))
            : temp;

        return temp;

    }, [arrAlerts, arrActiveAlert, objFilterAlertFromModal, strSearchAlertBySymbol, selectAllCheckbox]);
    // Vinit R - 24-04-2024 BT-107432 Breeze - Alerts -- End

    const strClassName = bShowDeleteCheckbox ? 'sticky-alert-height-fifty px-2' : 'sticky-alert-height-hundred';
    const [objScripsRequest, setObjScripsRequest] = useState({});
    const handleSideBarAlert = useCallback(async () => {
        let dahsboardWatchlistData = await scrollContainerObserver(containerRef, true);
        setObjScripsRequest(prevState => {
            let objpreviosScripsCopy = prevState;
            let arrWithKeys = [];
            let subscribeScrips = []; // This array is a non repeated subscrips for subscription
            let unSubScribeScrips = []; // this array is scrips of unsubscription]

            const arrVisibleRows = dahsboardWatchlistData.map(item => {
                let id = item;
                arrWithKeys?.push(id);
                if (!objpreviosScripsCopy[id]) {
                    objpreviosScripsCopy[id] = true;
                    subscribeScrips?.push({ exchangeId: Number(item?.split("_")[0]), token: Number(item?.split("_")[1]), isSubscribe: true });

                }
                return { exchangeId: Number(item?.split("_")[0]), token: Number(item?.split("_")[1]), isSubscribe: true };
            });
            Object?.keys(objpreviosScripsCopy)?.forEach(key => {
                if (!arrWithKeys.includes(key)) {
                    let obj = {
                        exchangeId: Number(key?.split('_')[0]),
                        token: Number(key?.split('_')[1]),
                        isSubscribe: false
                    };
                    unSubScribeScrips?.push(obj);
                    delete objpreviosScripsCopy[key];
                }
            });
            sendTouchlineRequest(unSubScribeScrips);
            sendTouchlineRequest(subscribeScrips);
            setTimeout(() => {
                const objLastTickData = dispatch(getWfhTouchlineLastTick());
                if (arrVisibleRows?.length > 0) {
                    arrVisibleRows?.forEach((each) => {
                        let key = each?.exchangeId + '_' + each?.token;
                        if (objLastTickData[key]) {
                            updateAlertWithTouchlineData(objLastTickData[key]);
                        }
                    });
                }
            }, 1000);

            return { ...objpreviosScripsCopy };
        });
    }, []);
    const handleScrollOfAlerts = useCallback(() => {
        handleSideBarAlert();
    }, [handleSideBarAlert]);

    useEffect(() => {
        const arrAlertsData = AlertPortfolio ? arrAlertAttributes : isVertical === false ? arrAlerts?.filter((each) => (each.segmentId + "_" + each.nToken) === scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) : arrAlerts || [];
        setArrActiveAlerts(arrAlertsData);
        handleSideBarAlert();

    }, [AlertPortfolio, arrAlerts, arrAlertAttributes,scripOverviewData,isVertical, handleSideBarAlert, dispatch]);
    const handleSideAlertsUnSubscription = useCallback(() => {
        handleScripUnsubScriptionOnUnMount(objScripsRequest, 'Side bar alerts');
    }, [objScripsRequest]);


    useUnload(() => {
        handleSideAlertsUnSubscription();
    });

    return (
        <Container fluid className='p-0'>
            {arrAlrtScripData.length > 0 ?
                <BzScrollContainer className={strClassName} onScrollEnd={(e) => handleScrollOfAlerts(e)} contaierref={containerRef}>
                    < div className='transparent-card-wrap' >
                        {arrAlrtScripData?.length > 0 && arrAlrtScripData?.map((each, i) => (
                            <BzCard key={i} id={each?.mktIdToken} className='transparent-card cursor-pointer bdr-btm'>
                                <Row className='g-0'>
                                    {bShowDeleteCheckbox &&
                                        <Col md='auto'>
                                            <input type="checkbox" className='form-check-input mt-1 me-2' checked={arrSelectedDeleteAlert?.includes(each)} onChange={handleSelectAlertForDelete.bind(this, each)} />
                                        </Col>
                                    }
                                    <Col>
                                        <Row className='g-0'>
                                            <Col md={8} className='d-flex justify-content-start align-self-center chips-wrap'>
                                                <div className='font-medium font-size3 color-text me-2'>{each?.symbol}</div>
                                            </Col>
                                            <Col md={4} className='d-flex justify-content-end align-self-center'>
                                                <div className='d-flex justify-content-end align-self-center'>
                                                    <div className='font-medium font-size3 color-text'>{each?.ltp}</div>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className='g-0 mb-1'>
                                            <Col md={8} className='d-flex justify-content-start align-items-center chips-wrap'>
                                                <BzChip className='exchange-chip me-2'>{each?.exchange}</BzChip>
                                                <AlertNameDetails alertData={each} />
                                            </Col>
                                            <Col md={4} className='d-flex justify-content-end align-self-center'>
                                                <div className='d-flex justify-content-end align-self-center'>
                                                    <div className={`font-regular font-size1 color-text me-1 ${each?.changeInPercent?.split("")[0] === '+' ? "color-positive" : (each?.changeInPercent?.split("")[0] === '-' ? "color-negative" : '')} `}>{each?.changeInPrice}</div>
                                                    <div className={`font-regular font-size1 color-text ${each?.changeInPercent?.split("")[0] === '+' ? "color-positive" : (each?.changeInPercent?.split("")[0] === '-' ? "color-negative" : '')} `}>({each?.changeInPercent}%)</div>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className='g-0 mb-1'>
                                            <Col md={8} className='d-flex justify-content-start align-self-center chips-wrap'>
                                                <div className='font-medium font-size3 color-text me-2'>{each?.alertCondition}</div>
                                            </Col>
                                            {!bShowDeleteCheckbox &&
                                                <Col md={4} className='d-flex justify-content-end align-self-center'>
                                                    <div className='icon-16 icon-delete icon-dark ms-3' onClick={handleDeleteSingleAlert?.bind(this, each)}></div>
                                                    <div className='icon-16 icon-edit icon-dark ms-3' onClick={handleEditAlert.bind(this, each)}></div>
                                                </Col>
                                            }
                                        </Row>
                                        <Row className='g-0 mb-2'>
                                            <Col md={8} className='d-flex justify-content-start'>
                                                <div className='font-regular font-size1 color-subtext'>Created: {each?.displayCreateDate}</div>
                                            </Col>
                                        </Row>
                                        <Row className='g-0 mb-2'>
                                            <Col className='justify-content-start align-self-center'>
                                                <div className='font-medium font-size3 color-text'>
                                                    <span className='font-regular font-size3 color-text'>{each?.remarks}</span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </BzCard>
                        ))}
                    </div>
                </BzScrollContainer>
                :
                <div className={`zero-state-alerts zero-state-alerts-${isVertical ? 'xl' : 'sm'}`}>
                    <ZeroStates subText="No alerts available" icon='icon-64 icon-alert icon-background-nodata mb-3 mrgauto' />
                </div>
            }
        </Container>
    );
};

export default (Alert);
//AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - End